import React, { useEffect, useCallback } from "react";
import { Container, Table, Col, Button } from "react-bootstrap";
import { useHistory, useParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import { fetchSimulationOnly } from "../../Redux/simulationReduce";


function DetailSimulation({ client }) {
    const dispatch = useDispatch();
    const navigate = useHistory();
    const location = useParams();
    const [entities, setEntities] = React.useState([]);
    const [tete, setEntitieTete] = React.useState([]);
    const [loader, setLoader] = React.useState(true);

    const getSimulation = useCallback(
        async () => {
            var PrixProd = await dispatch(fetchSimulationOnly({ id: location.id }));
            var findSimulation = await PrixProd.payload.arrayPrixProd;
            var tableRows = findSimulation.map((element, key) => (
                <tr key={"pp" + key}>
                    <td>{element.code_grossiste}</td>
                    <td>{element.code}</td>
                    <td>{element.Designation}</td>
                    <td>{element.valeur}</td>
                </tr>
            ));
            setEntities(tableRows);
            setLoader(false)
        },
        [dispatch, location.id]
    );


    const getentete = useCallback(
        async () => {
            var entete = await dispatch(fetchSimulationOnly({ id: location.id }));
            var findentete = await entete.payload.findEntete;
            var tableRows = findentete.map((element, key) => (
                <Table bordered hover style={{ textAlign: "center" }}>
                    <thead >
                        <tr>
                            <th>Nom file</th>
                            <th>Mois</th>
                            <th>Année</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>{element.nom_file}</td>
                            <td>{element.mois}</td>
                            <td>{element.annee}</td>
                        </tr>
                    </tbody>
                </Table>

            ));
            setEntitieTete(tableRows);
        },
        [dispatch, location.id]
    );

    useEffect(() => {
        getSimulation();
        getentete();
    }, [getSimulation, getentete]);



    function listepp() {
        navigate.push(client + "/listSimulation");
    }

    return (
        <>


            <Container fluid>

                <Col md="12">
                    <Button
                        id="saveBL"
                        className="btn-wd btn-outline mr-1 float-left"
                        type="button"
                        variant="info"
                        onClick={listepp}
                    >
                        <span className="btn-label">
                            <i className="fas fa-list"></i>
                        </span>
                        Retour à la liste
                    </Button>
                </Col>
                {loader ? (
                    <div className="loader-container">
                        <div className="loader"></div>
                    </div>
                ) : (
                    <div>
                        {tete}

                        <hr style={{ borderTop: "4px solid black" }}></hr>

                        <Table bordered hover>
                            <thead className="entete_detail">
                                <tr>
                                    <th>Code client</th>
                                    <th>Code article</th>
                                    <th>Désignation</th>
                                    <th>CMD VF</th>
                                </tr>
                            </thead>
                            <tbody>{entities}</tbody>
                        </Table>
                    </div>)}
            </Container>
        </>
    );
}

export default DetailSimulation;
